const styles = {
  icon: {
    border: '3px solid #f9f9f9',
    background: '#ffc561',
    color: '#f9f9f9',
  },
  dark: {
    background: 'rgba(58, 93, 65, 0.7)',
    border: '8px solid #f9f9f9',
    borderRadius: '16px',
    boxShadow: 'none',
  },
  light: {
    background: 'rgba(233, 237, 202, 0.7)',
    border: '8px solid #3a5d41',
    borderRadius: '16px',
    boxShadow: 'none',
  },
};

export default styles;
